/*
 *
 * DivisionAnalysis constants
 *
 */

export const GET_DRILLDOWN_DIVISIONS_WATCHER =
  "app/DivisionAnalysis/GET_DRILLDOWN_DIVISIONS_WATCHER"
export const GET_DRILLDOWN_DIVISIONS_SUCCESS =
  "app/DivisionAnalysis/GET_DRILLDOWN_DIVISIONS_SUCCESS"
export const GET_DRILLDOWN_DIVISIONS_FAILED =
  "app/DivisionAnalysis/GET_DRILLDOWN_DIVISIONS_FAILED"

export const GET_DIMENSIONS_WATCHER =
  "app/DivisionAnalysis/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/DivisionAnalysis/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED =
  "app/DivisionAnalysis/GET_DIMENSIONS_FAILED"

export const GRAPHIC_BARS_WATCHER = "app/DivisionAnalysis/GRAPHIC_BARS_WATCHER"
export const GRAPHIC_BARS_SUCCESS = "app/DivisionAnalysis/GRAPHIC_BARS_SUCCESS"
export const GRAPHIC_BARS_FAILED = "app/DivisionAnalysis/GRAPHIC_BARS_FAILED"

export const DIVISION_WITH_ENGAGEMENT_WATCHER =
  "app/DivisionAnalysis/DIVISION_WITH_ENGAGEMENT_WATCHER"
export const DIVISION_WITH_ENGAGEMENT_SUCCESS =
  "app/DivisionAnalysis/DIVISION_WITH_ENGAGEMENT_SUCCESS"

export const GET_MEASURE_COLOR_RANGE_WATCHER =
  "app/DivisionAnalysis/GET_MEASURE_COLOR_RANGE_WATCHER"
export const GET_MEASURE_COLOR_RANGE_SUCCESS =
  "app/DivisionAnalysis/GET_MEASURE_COLOR_RANGE_SUCCESS"

export const GET_MEASURE_WATCHER = "app/DivisionAnalysis/GET_MEASURE_WATCHER"
export const GET_MEASURE_SUCCESS = "app/DivisionAnalysis/GET_MEASURE_SUCCESS"
